module.exports = __webpack_public_path__ + "static/fallback-0b4fb13a31cbaa5c74a5c00042083426.png";